import React, {PropsWithChildren} from 'react';
import cn from "classnames";
import {useTranslation} from 'react-i18next';
import {FieldError, RegisterOptions, UseFormMethods} from 'react-hook-form';

import './form.scss';

interface IFormTextareaProps<FormValues> {
    dataCy?: string;
    defaultValue?: string | number;
    disabled?: boolean;
    form: UseFormMethods<FormValues>
    label: string;
    maxLength?: number;
    name: keyof FormValues & string;
    registerOptions?: RegisterOptions;
    rows?: number;
}

export function FormTextarea<ObjectType>(props: PropsWithChildren<IFormTextareaProps<ObjectType>>) {
    const {t, i18n} = useTranslation();
    const {defaultValue, disabled, form, label, maxLength, name, registerOptions} = props;

    const error = form.errors[name] as FieldError;
    let errorMessage = error?.message;
    // If we weren't passed a custom message for this error, use a generic one for its type.
    if (error && !errorMessage) {
        switch (error.type) {
            case 'required':
                errorMessage = t('errors.validation.required');
                break;
            default:
                errorMessage = t('errors.validation.fallback', {errorType: error.type});
                break;
        }
    }

    return (
        <div className={cn({
            formItem: true,
            error: !!error,
        })}>
            <div className="formItem_label">
                {label}
            </div>
            <textarea
                className="formItem_textarea"
                defaultValue={defaultValue}
                disabled={disabled}
                maxLength={maxLength}
                name={name}
                ref={form.register(registerOptions)}
                data-cy={props.dataCy}
                rows={props.rows || 2}
            />
            {error && (
                <div className="formItem_error" data-cy={props.dataCy + "_error"}>
                    {errorMessage}
                </div>
            )}
        </div>
    );
};